import {omit} from 'lodash'
import {useEffect} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {useParams} from 'react-router'
import {useHistory} from 'react-router-dom'

import {useTranslation} from '../../../../hooks/useTranslation'

import {SlotManagementConfigurationDetails} from './components/SlotManagementConfigurationDetails'
import {useSlotManagementConfigsCopyMutation} from './hooks/useSlotManagementConfigsMutation'
import {useSlotManagementConfigsQuery} from './hooks/useSlotManagementConfigsQuery'
import {SlotManagementConfig} from './types/SlotManagementConfig'

type SlotManagementCreateConfig = Omit<SlotManagementConfig, 'id'>

export const SlotManagementConfigurationCopy = () => {
  const {configId} = useParams<{
    configId?: string
  }>()

  const {t} = useTranslation()
  const history = useHistory()
  const slotManagementConfigsMutation = useSlotManagementConfigsCopyMutation()

  const slotManagementConfigQueryInfo = useSlotManagementConfigsQuery()

  const methods = useForm<SlotManagementCreateConfig>({
    defaultValues: {} as SlotManagementCreateConfig,
    mode: 'onChange'
  })

  useEffect(() => {
    if (configId && slotManagementConfigQueryInfo.data) {
      const config = slotManagementConfigQueryInfo.data.find((config) => config.id === configId)
      if (config) {
        const configWithoutId = omit(config, 'id')
        methods.reset(configWithoutId as SlotManagementCreateConfig)
      }
    }
  }, [configId, slotManagementConfigQueryInfo.data, methods])

  const handleCopyButtonClick = async (data: SlotManagementCreateConfig) => {
    try {
      await slotManagementConfigsMutation.mutateAsync(data)
      // Only navigate back on success
      history.goBack()
    } catch (error) {
      // Error is handled by mutation hook
      // serverErrorMessage is available for inline display
      // Don't navigate back - keep form open
    }
  }

  if (slotManagementConfigQueryInfo.isLoading || !slotManagementConfigQueryInfo.data) {
    return <div>{t('configurations.hconnect.slotManagement.configurationDetails.loading')}</div>
  }

  return (
    <FormProvider {...methods}>
      <SlotManagementConfigurationDetails
        mode="copy"
        configId={configId}
        onSaveButtonClick={methods.handleSubmit(handleCopyButtonClick)}
        isSubmitting={slotManagementConfigsMutation.isLoading}
      />
    </FormProvider>
  )
}
